import { httpClient } from '@/services/http/httpClient'

export async function deleteForumComment(id: string): Promise<void> {
  await httpClient.delete(`/ideas/forum/${id}`)
}
